var utils = require("../../utils/utils");

var StateService = (function(){
	var stateProviders = {};

	function getState(){
		var res = {};
		for(var i in stateProviders){
			utils.mixin(res, stateProviders[i](), true);
		}
		return res;
	}

	function registerProvider(name, provider){
		stateProviders[name] = provider;
	}

	function unregisterProvider(name){
		delete stateProviders[name];
	}

	return {
		getState: getState,
		registerProvider: registerProvider,
		unregisterProvider: unregisterProvider
	};
});

module.exports = StateService;




//////////////////
// WEBPACK FOOTER
// ./sources/core/common/state.js
// module id = 29
// module chunks = 0